<nz-header class="section-header">
  {{ "Balance and Gait" | translate }}
</nz-header>

@for (m of modules; track m.path) {
  @if (m.path === componentPaths.bergBalanceScale) {
    <app-questionnaire-history-table
      [id]="m.path"
      [questionnaireTemplateId]="8"
      [historyItems]="getTemplateItems(8)"
      [currentVisitId]="currentVisitId()"
      [isLoading]="overviewLoading"
      [error]="overviewError"
      [showAddButton]="isVisitMode() && !readonlyMode"
      (addRequested)="openVisitQuestionnaire($event)"
      (submissionSelected)="openQuestionnaireSubmission($event)"
      (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
    />
  }
  @if (m.path === componentPaths.miniBestest) {
    <app-questionnaire-history-table
      [id]="m.path"
      [questionnaireTemplateId]="19"
      [historyItems]="getTemplateItems(19)"
      [currentVisitId]="currentVisitId()"
      [isLoading]="overviewLoading"
      [error]="overviewError"
      [showAddButton]="isVisitMode() && !readonlyMode"
      (addRequested)="openVisitQuestionnaire($event)"
      (submissionSelected)="openQuestionnaireSubmission($event)"
      (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
    />
  }
  @if (m.path === componentPaths.sixMeterWalkTest) {
    <app-questionnaire-history-table
      [id]="m.path"
      [questionnaireTemplateId]="23"
      [historyItems]="getTemplateItems(23)"
      [currentVisitId]="currentVisitId()"
      [isLoading]="overviewLoading"
      [error]="overviewError"
      [showAddButton]="isVisitMode() && !readonlyMode"
      (addRequested)="openVisitQuestionnaire($event)"
      (submissionSelected)="openQuestionnaireSubmission($event)"
      (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
    />
  }
  @if (m.path === componentPaths.tenMeterWalkTest) {
    <app-questionnaire-history-table
      [id]="m.path"
      [questionnaireTemplateId]="24"
      [historyItems]="getTemplateItems(24)"
      [currentVisitId]="currentVisitId()"
      [isLoading]="overviewLoading"
      [error]="overviewError"
      [showAddButton]="isVisitMode() && !readonlyMode"
      (addRequested)="openVisitQuestionnaire($event)"
      (submissionSelected)="openQuestionnaireSubmission($event)"
      (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
    />
  }
  @if (m.path === componentPaths.functionalAmbulationCategory) {
    <app-questionnaire-history-table
      [id]="m.path"
      [questionnaireTemplateId]="25"
      [historyItems]="getTemplateItems(25)"
      [currentVisitId]="currentVisitId()"
      [isLoading]="overviewLoading"
      [error]="overviewError"
      [showAddButton]="isVisitMode() && !readonlyMode"
      (addRequested)="openVisitQuestionnaire($event)"
      (submissionSelected)="openQuestionnaireSubmission($event)"
      (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
    />
  }
  @if (m.path === componentPaths.functionalGaitAssessment) {
    <app-questionnaire-history-table
      [id]="m.path"
      [questionnaireTemplateId]="26"
      [historyItems]="getTemplateItems(26)"
      [currentVisitId]="currentVisitId()"
      [isLoading]="overviewLoading"
      [error]="overviewError"
      [showAddButton]="isVisitMode() && !readonlyMode"
      (addRequested)="openVisitQuestionnaire($event)"
      (submissionSelected)="openQuestionnaireSubmission($event)"
      (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
    />
  }
  @if (m.path === componentPaths.timeUpAndGoTest) {
    <app-questionnaire-history-table
      [id]="m.path"
      [questionnaireTemplateId]="27"
      [historyItems]="getTemplateItems(27)"
      [currentVisitId]="currentVisitId()"
      [isLoading]="overviewLoading"
      [error]="overviewError"
      [showAddButton]="isVisitMode() && !readonlyMode"
      (addRequested)="openVisitQuestionnaire($event)"
      (submissionSelected)="openQuestionnaireSubmission($event)"
      (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
    />
  }
  @if (m.path === componentPaths.modifiedAshworthScale) {
    <app-questionnaire-history-table
      [id]="m.path"
      [questionnaireTemplateId]="28"
      [historyItems]="getTemplateItems(28)"
      [currentVisitId]="currentVisitId()"
      [isLoading]="overviewLoading"
      [error]="overviewError"
      [showAddButton]="isVisitMode() && !readonlyMode"
      (addRequested)="openVisitQuestionnaire($event)"
      (submissionSelected)="openQuestionnaireSubmission($event)"
      (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
    />
  }
}
